import React from 'react';
import NavigationCategorySecondary from './NavigationCategorySecondary';
import FooterPrimary from './FooterPrimary';
import NavigationBrandsSecondary from './NavigationBrandsSecondary';
import NavigationCategoryOne from './NavigationCategoryOne';
import ProductFilterNavigationBar from '../Filter/ProductFilterNavigationBar';
import FixedFooterNavigation from './FixedFooterNavigation';

function Navigation(props) {
  const { type, ...rest } = props;

  switch (type) {
    case 'footer-primary':
      return <FooterPrimary {...rest} />;
    case 'fixed-footer-navigation':
      return <FixedFooterNavigation {...rest} />;
    case 'navigation-category-secondary':
      return <NavigationCategorySecondary {...rest} />;
    case 'navigation-brands-secondary':
      return <NavigationBrandsSecondary {...rest} />;
    case 'navigation-category-one':
      return <NavigationCategoryOne {...rest} />;
    case 'navigation-category-two':
      return <ProductFilterNavigationBar {...rest} />;
    case 'navigation-mobile-header':
      return <ProductFilterNavigationBar {...rest} />;
    default:
      return '';
  }
}

export default Navigation;
